import axios from 'axios';
import * as actionTypes from './Actiontypes';

const BASE_URL = "https://api.happiclips.com/api"

export const Createcontact = (first_name, last_name, email, message) => {
    const payload = {
        first_name, last_name, email, message
    }
    return async (dispatch) => {
        dispatch({
            type: actionTypes.CONTACT_US_INIT
        })
        try {
            const authToken = localStorage.getItem('authToken');
            const res = await axios.post(`${BASE_URL}/contact/create`, payload, {
                headers: {
                    Authorization: `Bearer ${authToken}`
                }
            });
            dispatch({
                type: actionTypes.CONTACT_US_SUCCESS,
                payload: res.data
            })
        }
        catch (error) {
            dispatch({
                type: actionTypes.CONTACT_US_FAIL,
                payload: 'error'
            })
            throw error;
        }
    }

}

export const sendReviewRequest = (guest_id, event_id) => {
    const payload = {
        guest_id, event_id
    }
    return async (dispatch) => {
        dispatch({
            type: actionTypes.SEND_REQ_REVIEW_INIT
        })
        try {
            const authToken = localStorage.getItem('authToken');
            const res = await axios.post(`${BASE_URL}/request-review`, payload, {
                headers: {
                    Authorization: `Bearer ${authToken}`
                }
            });
            dispatch({
                type: actionTypes.SEND_REQ_REVIEW_SUCCESS,
                payload: res.data
            })
            console.log(res.data)

        }
        catch (error) {
            dispatch({
                type: actionTypes.SEND_REQ_REVIEW_FAIL,
                payload: 'error'
            })

        }
    }

}

